module.exports = __webpack_public_path__ + "img/Gryphon-Line-Art.63f86c70.svg";